<template>
  <a-card bordered>
    <span slot="title">
      <a-tag color="green">{{ mode == "Create" ? "Create" : "Edit" }}</a-tag>
      Guaranteed Return
    </span>

    <a-form-model ref="form" :model="form" :rules="rules">
      <a-row :gutter="12">
        <a-col :xs="{ span: 24 }" :lg="{ span: 12 }">
          <a-form-model-item label="Type" prop="type">
            <a-radio-group buttonStyle="solid" v-model="form.type" @change="changeType">
              <a-radio-button value="1">As Winner</a-radio-button>
              <a-radio-button value="0">As Companion</a-radio-button>
            </a-radio-group>
          </a-form-model-item>
          <a-form-model-item label="Request Guarantee No" prop="bidBondNo">
            <a-select showSearch v-model="form.bidBondNo" :disabled="disabledNo" option-filter-prop="children"
              :filter-option="filterOption" @change="handlechangerequest">
              <a-select-option v-for="item in listnoBidbondrequ" :key="item.value">
                {{ item.text }}</a-select-option>
            </a-select>
            <div class="m-form-description-bold">Project Name : {{ form.labelingRequestNo }}</div>
          </a-form-model-item>
          <a-form-model-item label="Guarantee No" prop="guaranteeNo">
            <a-input v-model="form.guaranteeNo" />
          </a-form-model-item>
          <a-form-model-item label="Bank Account" prop="int_bank_account">
            <a-select showSearch v-model="form.int_bank_account">
              <a-select-option v-for="item in bank" :key="item.value">
                {{ item.text }}</a-select-option>
            </a-select>
          </a-form-model-item>
          <!-- <a-form-model-item label="Bank Account" prop="ext_bank_account"
            v-if="trigger_bankaccount"
            >
            <a-input v-model="form.ext_bank_account" v-if="trigger_bankaccount"/>
          </a-form-model-item> -->
          <!-- <a-form-model-item label="Account Number" prop="rekening_no"
            v-if="trigger_bankaccount"
            >
            <a-input v-model="form.rekening_no" v-if="trigger_bankaccount" />
          </a-form-model-item> -->

        </a-col>
        <a-col :xs="{ span: 24 }" :lg="{ span: 12 }">
          <a-form-model-item label="Nominal" prop="nominal">
            <a-input-number :disabled="true" class="m-width-full" v-model="form.nominal" @keydown="onlyNumber"
              :formatter="value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
              :parser="(value) => value.replace(/\\s?|(,*)/g, '')"></a-input-number>
          </a-form-model-item>
          <a-form-model-item label="Note" prop="note">
            <a-textarea v-model="form.note" :rows="5"></a-textarea>
          </a-form-model-item>
          <a-form-model-item ref="file" prop="file" label="File Attachment">
            <a-upload v-model="form.file" :showUploadList="true" :fileList="push" :beforeUpload="beforeUpload"
              :remove="handleRemoveList">
              <a-button ref="btndocument" icon="upload">Select File
              </a-button>
            </a-upload>
          </a-form-model-item>
        </a-col>
      </a-row>
    </a-form-model>
    <div class="action">
      <a-button :loading="loading.submit" type="primary" @click="handleSave()">Save</a-button>
    </div>
  </a-card>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment";
import GlobalMethod from "@/mixins/GlobalMethod.js";
import _ from "lodash";

export default {
  name: "bidBond-create",
  props: ["id"],
  mixins: [GlobalMethod],
  data() {
    let bankaccountValidation1 = (rule, value, callback) => {
      if (!this.form.int_bank_account && this.submit_bankaccount) {
        callback(new Error("Please select Bank Account!"));
      } else {
        callback();
      }
    };
    let bankaccountValidation2 = (rule, value, callback) => {
      if (!this.form.ext_bank_account && this.submit_bankaccount) {
        callback(new Error("Please select Bank Account!"));
      } else {
        callback();
      }
    };
    let doc_validation = (rule, value, callback) => {
      if (this.push == null || this.push.length == 0) {
        callback(new Error("Please input File Attachment"));
      } else {
        callback();
      }
    };
    return {
      mode: "Create",
      loading: {
        submit: false,
      },
      trigger_bankaccount: false,
      submit_bankaccount: false,
      form: {
        type: "1",
        bidBondNo: null,
        guaranteeNo: null,
        int_bank_account: null,
        ext_bank_account: null,
        duedate: null,
        nominal: null,
        file: null,
        rekening_no: null,
        contractperson: null,
        funding: null,
        note: null,
        labelingRequestNo: null,
      },
      dataedit: {},
      rules: {
        date: {
          required: true,
          message: "Please input Date",
          trigger: "blur",
        },
        bidBondNo: {
          required: true,
          message: "Please input Request Guarantee No",
          trigger: "blur",
        },
        guaranteeNo: {
          required: true,
          message: "Please input Guarantee No",
          trigger: "blur",
        },
        int_bank_account: {
          required: true,
          trigger: "blur",
          validator: bankaccountValidation1
        },
        ext_bank_account: {
          required: true,
          trigger: "blur",
          validator: bankaccountValidation2
        },
        nominal: {
          required: true,
          message: "Please input Nominal",
          trigger: "blur",
        },
        file: {
          required: true,
          validator: doc_validation,
          trigger: "change",
        },
        rekening_no: {
          required: true,
          message: "Please input Account Number",
          trigger: "blur",
        },
        type: {
          required: true,
          message: "Please input Type",
          trigger: "blur",
        },
        note: {
          required: true,
          message: "Please input Note",
          trigger: "blur",
        },
      },
      bank: {},
      push: [],
      listnoBidbondrequ: {},
      disabledNo: true
    };
  },
  computed: {
    ...mapGetters(["getAuth", "getDefaultDateFormat", "getStandartFormatDate",
      "getListBidBond"]),
  },
  watch: {
    dataedit() {
      this.initialData();
    },
  },
  mounted() {
    this.fetch();
    this.initialData();
  },
  methods: {
    moment,
    initialData() {
      this.form = {
        date:
          this.mode == "Edit"
            ? moment(this.dataedit.create_dt).format(this.getStandartFormatDate)
            : moment(),
        bidBondNo: this.mode == "Edit" ? this.dataedit.bidBondNo : null,
        int_bank_account: this.mode == "Edit" ? this.dataedit.int_bank_account : null,
        ext_bank_account: this.mode == "Edit" ? this.dataedit.ext_bank_account : null,
        duedate: this.mode == "Edit" ? this.dataedit.duedate : null,
        nominal: this.mode == "Edit" ? this.dataedit.nominal : null,
        file: this.mode == "Edit" ? parseInt(this.dataedit.file) : 0,
        rekening_no: this.mode == "Edit" ? this.dataedit.rekening_no : null,
        contractperson: this.mode == "Edit" ? this.dataedit.contractperson : null,
        funding: this.mode == "Edit" ? this.dataedit.funding : null,
        type: this.mode == "Edit" ? this.dataedit.type : "1",
        note: this.mode == "Edit" ? this.dataedit.note : null,
      };
    },
    fetch() {
      this.$store
        .dispatch("getListBankBidBond", { auth: this.getAuth })
        .then((res) => {
          this.bank = res;
        });

      this.disabledNo = true;
      let stype = this.form.type;
      this.$store
        .dispatch("getListnoBidBondRequest", { auth: this.getAuth, type: stype })
        .then((res) => {
          console.log(res);
          this.listnoBidbondrequ = res;
          this.disabledNo = false;
        });
      this.changeType();
      // if (this.id) {
      //   this.$store
      //     .dispatch("FetchEditBank", { auth: this.getAuth, params: this.id })
      //     .then((res) => {
      //       this.dataedit = res;
      //       this.mode = "Edit";
      //     });
      // }
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toUpperCase()
          .indexOf(input.toUpperCase()) >= 0
      );
    },
    changeType() {
      this.disabledNo = true;
      let stype = this.form.type;
      this.form.bidBondNo = null;
      this.form.labelingRequestNo = null;
      this.$store
        .dispatch("getListnoBidBondRequest", { auth: this.getAuth, type: stype })
        .then((res) => {
          //console.log(res);
          this.listnoBidbondrequ = res;
          this.disabledNo = false;
        });

      if (this.form.type == '1') {
        this.form.int_bank_account = null;
        this.form.rekening_no = null;
        this.trigger_bankaccount = true;
      } else {
        this.form.ext_bank_account = null;
        this.trigger_bankaccount = false;
      }
      this.form.nominal = null;
    },
    handleSave() {
      this.submit_bankaccount = true;
      this.$refs.form.validate((valid) => {
        if (!valid) {
          this.displayMessage("form-warning");
          this.submit_bankaccount = false;
          return;
        }
        this.loading.submit = true;

        let data = new FormData();
        data.append("tlc", this.getAuth.username);
        data.append("type_refund", this.form.type);
        data.append("guarantee_no", this.form.guaranteeNo);
        if (this.form.type == '1') {
          let idx = _.filter(this.listnoBidbondrequ, item =>
            item.value.indexOf(this.form.bidBondNo) >= 0);
          data.append("request_bidbond", idx[0].bidbond_request_id);
          data.append("request_bidbond_dtl_id", this.form.bidBondNo);
          data.append("companion_nm", idx[0].companion_name);
        } else {
          data.append("request_bidbond", this.form.bidBondNo);
        }
        // if (this.form.type=='0'){
        let ids = this.form.int_bank_account;
        let bankfix = _.filter(this.bank, item =>
          item.value.indexOf(ids) >= 0);
        data.append("bank_account", ids);
        data.append("rekening_no", bankfix[0].kode_rekening);
        // }else{
        //   data.append("bank_account_to",this.form.int_bank_account);
        //   data.append("rekening_no",this.form.rekening_no);
        // }
        data.append("nominal", this.form.nominal);
        data.append("note", this.form.note);
        data.append("upload_file", this.push[0]);

        this.$store
          .dispatch("submitBidBond", { auth: this.getAuth, payload: data })
          .then((res) => {
            this.displayMessage("success");
            this.loading.submit = false;
            this.$router.go(-1);
          })
          .catch((err) => {
            this.displayMessageValue("basic-error", err.response.data.message);
            this.loading.submit = false;
          });
      });
    },
    handleRemoveList() {
      this.form.file = undefined;
      this.push = [];
    },
    beforeUpload(file) {
      const FileSize = file.size / 1024 / 1024;
      if (FileSize > 5) {
        this.displayMessage("large-file-5mb");
      } else {
        this.push = [file];
        return false;
      }
    },
    handlechangerequest(val) {
      let scopedata = _.filter(this.listnoBidbondrequ, item =>
        item.value.indexOf(val) >= 0);
      this.form.nominal = scopedata[0].nominal;
      this.form.labelingRequestNo = scopedata[0].project_name;
    }
  },
};
</script>

<style lang="less" scoped>
.action {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin: @padding -@padding -@padding -@padding;
  padding: @padding;
  background-color: darken(white, 5);
  border-top: 1px solid darken(white, 10);
}
</style>
